import { delay } from 'redux-saga';

import { call, put, all } from 'redux-saga/effects';
import * as api from 'reduxStore/apiService';
import apiUrl from 'common/api-url';
import {
  FBEIntegrationAssetsPayload,
  integrationAssetsSuccess,
  integrationAssetsFailure,
} from '../actions';
import { fbeIntegrationAssetsRequested } from '../sagas';
import {
  businessConfigSuccess,
  businessConfigFailure,
  FBEBusinessConfigPayload,
  installFBESuccess,
} from './actions';

import { FacebookBusinessExtensionAnalytics as Analytics } from './tracking';

export const FBE_POST_INTEGRATION_DELAY = 4000;

const getConnectedAccounts = (assets?: FBEIntegrationAssetsPayload) => ({
  facebook_connected: Boolean(assets?.pageId),
  instagram_connected: Boolean(assets?.instagramBusinessId),
});

export function* businessConfigFBERequested() {
  try {
    const response: FBEBusinessConfigPayload = yield call(api.get, apiUrl('FBE_BUSINESS_CONFIG'));
    yield put(businessConfigSuccess(response));
  } catch (responseError) {
    Analytics.trackBusinessConfigFailure();
    yield put(businessConfigFailure());
  }
}

export function* integrationFBECompleted() {
  const [, integrationAssets]: [unknown, FBEIntegrationAssetsPayload | undefined] = yield all([
    call(delay, FBE_POST_INTEGRATION_DELAY),
    call(fbeIntegrationAssetsRequested),
  ]);
  if (integrationAssets) {
    Analytics.trackFBESuccess(getConnectedAccounts(integrationAssets));
  } else {
    Analytics.trackIntegrationAssetsFailure();
  }
  yield put(installFBESuccess());
}

export function* reintegrationFBECompleted() {
  try {
    const response: FBEIntegrationAssetsPayload = yield call(
      api.get,
      apiUrl('FBE_INTEGRATION_ASSETS'),
    );
    const connectedAccounts = getConnectedAccounts(response);
    if (response.instagramBusinessId) {
      Analytics.trackFBEReintegrationSuccess(connectedAccounts);
    } else {
      Analytics.trackFBEReintegrationFailure(connectedAccounts);
    }
    yield put(integrationAssetsSuccess(response));
    yield put(installFBESuccess());
  } catch (responseError) {
    Analytics.trackReintegrationAssetsFailure();
    yield put(integrationAssetsFailure());
  }
}
